// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"Ot-z","hovered":"Pt-z","hoverImage":"Qt-z","mainImage":"Rt-z","imageNoBackground":"St-z","fullSizeImage":"Tt-z"};